import { createContext, useContext } from 'react';

/**
 * Identifies the calculator page to descendants (DetailSection uses it to
 * namespace the persisted open/closed state of each detail section).
 */
export const CalculatorPageContext = createContext<{ id: string }>({ id: 'calculator' });

export function useCalculatorPage() {
  return useContext(CalculatorPageContext);
}
